import { traceLoggingDispatcher } from "./TraceLoggingDispatcher";
// Wrapper class for WebXT Telemetry
// This class should only be used in specific cases, such as delaying a telemetry payload if Feed is not ready
export class DispatchOnly {
    static logEvent(provider, eventName, dmaDataCategory, privacyTag, partC) {
        traceLoggingDispatcher.dispatch(eventName, provider, dmaDataCategory, privacyTag, 70368744177664 /* measures */, 0 /* none */, 0 /* verbose */, partC);
    }
    static logEventWithTag(provider, eventName, dmaDataCategory, privacyTag, eventTag, partC) {
        traceLoggingDispatcher.dispatch(eventName, provider, dmaDataCategory, privacyTag, 70368744177664 /* measures */, eventTag, 0 /* verbose */, partC);
    }
    static logEventWithLevel(provider, eventName, dmaDataCategory, privacyTag, loggingLevel, partC) {
        traceLoggingDispatcher.dispatch(eventName, provider, dmaDataCategory, privacyTag, 70368744177664 /* measures */, 0 /* none */, loggingLevel, partC);
    }
    static logEventWithLevelAndTag(provider, eventName, dmaDataCategory, privacyTag, loggingLevel, eventTag, partC) {
        traceLoggingDispatcher.dispatch(eventName, provider, dmaDataCategory, privacyTag, 70368744177664 /* measures */, eventTag, loggingLevel, partC);
    }
}
